import { render, staticRenderFns } from "./platformAuth.vue?vue&type=template&id=018377f2&scoped=true"
import script from "./platformAuth.vue?vue&type=script&lang=js"
export * from "./platformAuth.vue?vue&type=script&lang=js"
import style0 from "./platformAuth.vue?vue&type=style&index=0&id=018377f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018377f2",
  null
  
)

export default component.exports